export const API_METHODS = {
  GET: "get",
  POST: "post",
  PUT: "put",
  DELETE: "delete",
};

const normalizePart = (value, { trimLeadingSlash = false } = {}) => {
  if (!value) {
    return "";
  }

  let normalized = String(value).trim();

  if (trimLeadingSlash) {
    normalized = normalized.replace(/^\//, "");
  }

  normalized = normalized.replace(/\/+$/, "");
  return normalized;
};

const getRuntimeConfig = () => {
  if (typeof window === "undefined") {
    return {};
  }

  return window.__APP_CONFIG__ || {};
};

const runtimeConfig = getRuntimeConfig();

const preferRuntime = (runtimeValue, envValue) => {
  const hasValue = (value) =>
    value !== undefined && value !== null && value !== "";

  if (hasValue(runtimeValue)) {
    return runtimeValue;
  }

  if (hasValue(envValue)) {
    return envValue;
  }

  return "";
};

const apiBase = normalizePart(
  runtimeConfig.API_URL ?? import.meta.env.APP_API_URL
);
const apiVersion = normalizePart(
  runtimeConfig.API_VERSION ?? import.meta.env.APP_API_VERSION,
  {
    trimLeadingSlash: true,
  }
);
const kycEndpoint = normalizePart(
  runtimeConfig.KYC_ENDPOINT ?? import.meta.env.APP_KYC_ENDPOINT,
  {
    trimLeadingSlash: true,
  }
);

export const API_URL = [apiBase, apiVersion, kycEndpoint].filter(Boolean).join("/");
export const GTM_ID = runtimeConfig.GTM_ID ?? import.meta.env.APP_GTM_ID;
export const GLOBE_URL =
  runtimeConfig.GLOBE_URL ?? import.meta.env.APP_GLOBE_URL;
export const GLOBE_SUPERAPP_URL =
  runtimeConfig.GLOBE_SUPERAPP_URL ?? import.meta.env.APP_GLOBE_SUPERAPP_URL;

if (!apiBase) {
  // eslint-disable-next-line no-console
  console.error(
    "API base URL is not configured. Ensure APP_API_URL is provided at build or runtime."
  );
}

export const ONBOARDING_SESSION_KEY = "onboarding-session-active";
